import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { MY_PURCHASES_V2 } from 'my-purchases/constants/endpoints'
import { normalizeData } from 'my-purchases/hooks/useActivePurchases/normalization'
import { useFetch } from 'my-purchases/hooks/useFetch/useFetch'
import { useFormatPrice } from 'my-purchases/hooks/useFormatPrice/useFormatPrice'
import type { Purchase } from 'my-purchases/types/purchaseList'
import { useSession } from 'session/src/hooks/useSession'
import useSWRImmutable from 'swr/immutable'
import { StatusCode } from 'types/statusCodes'
import { url } from 'utils/url'

export const useInactivePurchases = (disabled = false) => {
	const { fetcher } = useFetch()
	const { channel, country } = useMasterData()
	const { isReady, logged } = useSession()
	const { formatPrice } = useFormatPrice()

	const { data, error, isLoading, isValidating, mutate } = useSWRImmutable<{
		resolveData: Purchase[]
		status: number
	} | null>(
		isReady && logged && !disabled
			? {
					url: url(`${MY_PURCHASES_V2}/${channel}/purchases/inactive`),
				}
			: null,
		fetcher,
		{}
	)
	const { resolveData, status } = data ?? {}
	const statusErrorCode =
		status === StatusCode.MULTI_STATUS ? status : error?.status

	return {
		purchases:
			resolveData &&
			normalizeData({ purchases: resolveData, country, formatPrice }),
		error: statusErrorCode,
		isError: !!statusErrorCode,
		reload: mutate,
		isLoading: isLoading || isValidating,
	}
}
